import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import AcGroupLogo from "../../assets/img/acgroup-logo.png";
import OperatorLogo from "../../assets/img/bus.png";
import SafariLogo from "../../assets/img/logo.svg";
import CentrikaLogo from "../../assets/img/logo.png";
import Buses from "../../assets/img/bus_black.png";
import TicketsIcon from "../../assets/img/tickets.png";
import MoneyIcon from "../../assets/img/money.png";
import InterchangeIcon from "../../assets/img/interchange.png";
import Empty from "../../assets/svg/empty.svg";
import PropTypes from 'prop-types';
import { CSVLink, CSVDownload } from 'react-csv';

import RuraLogo from "../../assets/img/logorura.png";

import {
    Button,
    Drawer,
    ListItemText,
    IconButton,
    ListItemIcon,
    ListItem,
    Divider,
    List,
    Grid,
    Paper,
    Typography,
    Toolbar,
    AppBar,
    Container,
    Box,
    Hidden,
    Menu,
    MenuItem,
    Avatar,
    useMediaQuery,
    Badge,
    ButtonBase,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Tabs, Tab, Chip, TextField, LinearProgress,
    ListItemSecondaryAction,
    CircularProgress,
    ButtonGroup,
    Popover,
    Switch,
    FormControlLabel,
    InputLabel,
    FormControl, Lebal, Select, CardActionArea

} from "@material-ui/core";

import {
    Menu as MenuIcon,
    Home,
    Equalizer,
    Settings,
    ExitToApp,
    ArrowDropDown,
    HelpRounded,
    Notifications,
    Group,
    SupervisedUserCircle,
    Store,
    Security,
    AllInclusive,
    Gavel,
    Schedule,
    Subway,
    AirportShuttle,
    CreditCard,
    Block,
    Mail,
    Place,
    DepartureBoard,
    Assignment,
    Category,
    Assessment,
    ExpandLess,
    ExpandMore,
    ArrowRight,
    Timeline,
    MoneyOff,
    LocalAtm,
    WbIncandescentOutlined,
    DevicesOther, TrendingUp, ImportExport, ArrowDropUp, ConfirmationNumber,
    AccountBalance, AccountBalanceWallet, SwapHoriz,
    PeopleAltOutlined, DevicesOtherOutlined,
    OutlinedFlagOutlined, SettingsOutlined,
    Visibility, SettingsCell,
    AccountCircleOutlined,
    ArrowForwardIos,
    ImportantDevices,
    Language, Done,
    AccountBalanceWalletOutlined,
    PaymentOutlined, CancelPresentationOutlined,
    PhoneAndroidOutlined,
    CheckCircleOutlined,
    CheckCircleOutline,
    Devices,
    HdrWeak,
    AlternateEmail,
    PhoneAndroid,
    VpnKey,
    Edit,
    HighlightOff,
    Event,
    Money,
    Public, InsertDriveFileOutlined,
    EventAvailable,
    EventBusy,
    AssessmentOutlined,
    Today,
    FindReplace,
    DateRange,
    CalendarToday,
    AccountCircle,
    FilterList,
    Add, Close, DirectionsBus
}
    from "@material-ui/icons";

import { makeStyles, useTheme, withStyles } from "@material-ui/styles";
import { Speed } from "@material-ui/icons";

import { withLocalize, Translate } from "react-localize-redux";

import { Link, Route, useHistory } from "react-router-dom";

import Chart from "react-apexcharts";

import { useSnackbar } from 'notistack';

import MUIDataTable from "mui-datatables";

import CardTopup from "../../assets/svg/wallet.svg";
import Asettings from "../../assets/svg/asettings.svg";

import cBalance from "../../assets/svg/balance.svg";

import oBalance from "../../assets/svg/openbalance.svg";

import reserved from "../../assets/svg/reserved.svg";

import FloatAllocation from "../../assets/svg/float_allocation.svg";

import { weeklyTopup, AnnualTopUp } from "./test_data";
import UserInfo from "./login_info";
import axios from 'axios';
import { AdminService, FinanceService, ReportingService } from "./../../utils/web_config_2";

import Format from "date-fns/format";


import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { groupBy } from "./../../utils/web_config_2";

import { Skeleton } from "@material-ui/lab";
import { TransportService } from "../../utils/web_config";


const useStyles = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow: 1,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 250,
        }
    },
    title: {
        flexGrow: 1,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        // backgroundColor: "#1876d2"
    },
    btn2: {
        textTransform: "capitalize",
        borderRadius: 15,
        backgroundColor: "white"
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    btn: {
        textTransform: "capitalize",
    },
    paper: {
        padding: 15,
    },
    icon: {
        height: 50,
        marginRight: 10,
        display: "block",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
        backgroundColor: "#18469d",
        paddingBottom: "5px",
        paddingTop: "5px",
        paddingRight:"10px",
        paddingLeft: "10px",
        borderRadius: "10px"
    },

    iconCent: {
        height: 58,
        marginRight: 10,
        display: "block",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
        backgroundColor: "#ffffff",
        paddingBottom: "5px",
        paddingTop: "5px",
        paddingRight: "10px",
        paddingLeft: "10px",
        borderRadius: "10px"
    },
    main: theme.mixins.toolbar
}));

const AntSwitch = withStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow: 1,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 250,
        }
    },
    container: {

    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}


function Dashboard(props) {


    // const jsonData = [
    //     { name: 'John Doe', age: 30, email: 'john.doe@example.com' },
    //     { name: 'Jane Doe', age: 25, email: 'jane.doe@example.com' },
    // ];

    const [jsonData, setJsonData] = useState([]);

    const headers = [
        { label: 'Ticket ID', key: 'ticket_id' },
        { label: 'Ticket Reference', key: 'ticket_reference' },
        { label: 'Device ID', key: 'device_id' },
        { label: 'Amount', key: 'amount' },
        { label: 'Transaction Date', key: 'tx_date' },
        { label: 'Transaction Time', key: 'tx_time' },
        { label: 'Card ID', key: 'wallet_id' },
        { label: 'Plate Number', key: 'plate_number' },
        { label: 'Route Name', key: 'route_name' },
        { label: 'Organization Name', key: 'organization_name' },
    ];

    const classes = useStyles();
    const Theme = useTheme();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const matches = useMediaQuery(Theme.breakpoints.up("sm"));
    const menuOpen = Boolean(anchorEl);



    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [agentData, setAgentData] = useState({});
    const [agentProfile, setAgentProfile] = useState({});

    const [filterDialog, setFilterDialog] = useState(false)


    const [acData, setAcData] = useState({});

    useEffect(() => {

        var accountData = new AdminService().accountData;
        setAcData(accountData)
        // get_tickets_summary(accountData.token);

        get_revenue_organization(accountData.token,"AC_GROUP",day,endDay)
        get_revenue_organization(accountData.token, "SAFARIBUS", day, endDay)

        get_revenue_route(accountData.token, "SAFARIBUS", day, endDay)
        get_revenue_route(accountData.token, "AC_GROUP", day, endDay)

        get_revenue_plate_number(accountData.token, "AC_GROUP", day, endDay)
        get_revenue_plate_number(accountData.token, "SAFARIBUS", day, endDay)

        get_revenue_tickets(accountData.token, "SAFARIBUS", day, endDay)
        get_revenue_tickets(accountData.token, "AC_GROUP", day, endDay)

        get_revenue_channel(accountData.token, "SAFARIBUS", day, endDay)
        get_revenue_channel(accountData.token, "AC_GROUP", day, endDay)

        get_weekly_report(accountData.token, "AC_GROUP")
        get_weekly_report(accountData.token, "SAFARIBUS")

        get_monthly_report(accountData.token,"AC_GROUP",new Date().getFullYear())
        get_monthly_report(accountData.token,"SAFARIBUS",new Date().getFullYear())

        load_meta_data(accountData.token, "AC_GROUP", day, endDay)
        load_meta_data(accountData.token, "SAFARIBUS", day, endDay)
    }, []);



    // load meta data 
    const load_meta_data = (token, provider, start, end) => {
        const data = {
            "end_date": end,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": start
        };

        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_INETEROPERABILITY_META_REPORT, data)
            .then(res => {
                if (provider === "AC_GROUP"){
                    const data = res.data
                    setCentTaps(data.totalTaps);
                    setCentAmount(data.totalAmount);
                }else{
                    const data = res.data
                    setAcTaps(data.totalTaps);
                    setAcAmount(data.totalAmount);
                }
                
            })
            .catch(err => {

            });
    }

    const [currency, setCurrency] = useState("");
    // format money 
    function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            console.log(e)
        }
    };


    /// show transactions 



    const [filterType, setFilterType] = useState("");



    const [transactions, setTransactions] = useState([]);
    const [transactionLoad, setTransactionLoad] = useState(false);
    const [day, setDay] = useState(Format(new Date(), ["yyyy-MM-dd",]));
    const [endDay, setEndDay] = useState(Format(new Date(), ["yyyy-MM-dd",]));

    const [totalTaps, setTotalTaps] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    const get_tickets_summary = (token) => {

        setTransactionLoad(true);
        setTransactions([])

        axios.defaults.baseURL = new FinanceService().BASE_URL;
        const transactionsInstance = axios.create(new FinanceService().setHeaders(token));
        // transactionsInstance.get(new FinanceService().GET_AC_GROUP_TICKETS + "?start_date=2023-04-17&end_date=2023-04-17")
        transactionsInstance.get(new FinanceService().GET_AC_GROUP_TICKETS + "?start_date=" + day + "&end_date=" + endDay)
            .then(res => {
                var objs = res.data.data;
                if (objs.length > 0) {
                    setTransactions(objs)

                    // start calculate sum
                    var totalT = objs.reduce((a, b) => {
                        return a + parseInt(b.total_taps);
                    }, 0);
                    var totalA = objs.reduce((a, b) => {
                        return a + parseInt(b.total_amount);
                    }, 0);

                    setTotalTaps(totalT);
                    setTotalAmount(totalA);

                    // end calculate sum

                }
                setTransactionLoad(false);
            })
            .catch(err => {
                setTransactionLoad(false);
            });
    };


    // filter ac group tickets

    const [filterLoad, setFilterLoad] = useState(false);
    const [isValidDownload, setIsValidDownload] = useState(false);
    const get_ac_group_tickets = () => {
        setJsonData([])
        setIsValidDownload(false);
        setFilterLoad(true);
        axios.defaults.baseURL = new FinanceService().BASE_URL;
        const transactionsInstance = axios.create(new FinanceService().setHeaders(acData.token));
        transactionsInstance.get(new FinanceService().GET_AC_GROUP_TICKETS_REPORT + "?start_date=" + day + "&end_date=" + endDay)
            .then(res => {
                var data = res.data.data;
                if (data.length > 0) {
                    setJsonData(data)
                    setIsValidDownload(true);
                }

                // enqueueSnackbar("Report generated successful", {
                //     variant: "success",
                //     action: (k) => (
                //         <IconButton
                //             onClick={() => {
                //                 closeSnackbar(k);
                //             }}
                //             size="small"
                //         >
                //             <Close fontSize="small" />
                //         </IconButton>
                //     ),
                // });
                setFilterLoad(false);
                // setFilterDialog(false);
            })
            .catch(err => {
                setFilterLoad(false);
            });
    };
    // filter ac group tickets


    const [company, setCompany] = useState("");
    const get_ac_group_tickets_per_company = () => {
        setJsonData([])
        setIsValidDownload(false);
        setFilterLoad(true);
        axios.defaults.baseURL = new FinanceService().BASE_URL;
        const transactionsInstance = axios.create(new FinanceService().setHeaders(acData.token));
        transactionsInstance.get(new FinanceService().GET_AC_GROUP_TICKETS_REPORT + "?start_date=" + day + "&end_date=" + endDay + "&company_name=" + company)
            .then(res => {
                var data = res.data.data;
                if (data.length > 0) {
                    setJsonData(data)
                    setIsValidDownload(true);
                }

                // enqueueSnackbar("Report generated successful", {
                //     variant: "success",
                //     action: (k) => (
                //         <IconButton
                //             onClick={() => {
                //                 closeSnackbar(k);
                //             }}
                //             size="small"
                //         >
                //             <Close fontSize="small" />
                //         </IconButton>
                //     ),
                // });
                setFilterLoad(false);
                // setFilterDialog(false);
            })
            .catch(err => {
                setFilterLoad(false);
            });
    };






    const [logoutOpen, setLogoutOpen] = useState(false);




    /// start metrics 

    const [route_performance_revenue, set_route_performance_revenue] = useState({

        series: [{
            name: 'Percentage',
            data: []
        }],
        options: {
            chart: {
                height: 350,
                type: 'area'
            },
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            colors: ["#febe37"],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: []
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "%"
                    }
                }
            },
        },


    })
    const [ac_route_performance_revenue, set_ac_route_performance_revenue] = useState({

        series: [{
            name: 'Percentage',
            data: []
        }],
        options: {
            chart: {
                height: 350,
                type: 'area'
            },
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: []
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "%"
                    }
                }
            },
        },


    })

    const [organizationChart, setorganizationChart] = useState({
        options: {
            series: [],
            chart: {
                type: 'donut',
                width: 300,
                height: 300
            },
            labels: [],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            legend: {
                position: 'right',
                itemMargin: {
                    horizontal: 0
                }
            },
            responsive: [{
                breakpoint: 1000,
                options: {
                    chart: {
                        width: 250,
                        height: 250
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        }
    });

    const [ac_organizationChart, set_ac_organizationChart] = useState({
        options: {
            series: [],
            chart: {
                type: 'donut',
                width: 300,
                height: 300
            },
            labels: [],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            legend: {
                position: 'right',
                itemMargin: {
                    horizontal: 0
                }
            },
            responsive: [{
                breakpoint: 1000,
                options: {
                    chart: {
                        width: 250,
                        height: 250
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        }
    });

    const [ac_revenue_bv, set_ac_Revenue_bv] = useState(

        {
            options: {
                series: [{
                    name: 'Revenue',
                    data: []
                }],
                chart: {
                    height: 350,
                    type: 'bar',
                    tools: {
                        download: false,
                        selection: false,
                        pan: false,
                        reset: false,
                    }
                },

                noData: {
                    text: "No data yet",
                    align: "center",
                    verticalAlign: "middle",
                    offsetX: 0,
                    offsetY: 0,
                },
                plotOptions: {
                    bar: {
                        columnWidth: '40%',
                    }
                },
                dataLabels: {
                    enabled: false,
                    formatter: function (val) {
                        return formatMoney(val, 0) + " FRW";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: [],
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            return '<div class="arrow_box" style="padding:10">' +
                                '<span>' + formatMoney(parseInt(series[seriesIndex][dataPointIndex])) + ' FRW </span>' +
                                '</div>'
                        }
                    },
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return formatMoney(parseInt(val)) + " ";
                        }
                    }

                },

            }
        });

    const [revenue_bv, setRevenue_bv] = useState(

        {
            options: {
                series: [{
                    name: 'Revenue',
                    data: []
                }],
                chart: {
                    height: 350,
                    type: 'bar',
                    tools: {
                        download: false,
                        selection: false,
                        pan: false,
                        reset: false,
                    }
                },

                noData: {
                    text: "No data yet",
                    align: "center",
                    verticalAlign: "middle",
                    offsetX: 0,
                    offsetY: 0,
                },
                plotOptions: {
                    bar: {
                        columnWidth: '40%',
                    }
                },
                dataLabels: {
                    enabled: false,
                    formatter: function (val) {
                        return formatMoney(val) + " FRW";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: [],
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#b888da',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            return '<div class="arrow_box" style="padding:10">' +
                                '<span>' + formatMoney(parseInt(series[seriesIndex][dataPointIndex])) + ' FRW </span>' +
                                '</div>'
                        }
                    },
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return formatMoney(parseInt(val)) + " ";
                        }
                    }

                },

            }
        });


    const [ac_route_performance_passenger, set_ac_Route_performance_passenger] = useState({

        series: [{
            name: 'Percentage',
            data: [5000, 3000]
        }],
        options: {
            chart: {
                type: 'bar',
                height: 350
            },
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: false,
                    startingShape: "flat",
                    barHeight: "40%",
                    endingShape: "rounded",
                    dataLabels: {
                        position: "top",
                    },
                },
            },
            colors: ['#B578EF', '#FDD8B5', '#26E59F', '#92D7BB', '#FFEC42'],
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: ["CENTRIKA", "AC Mobility"],
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "%"
                    }
                }
            },
        },
    });


    const [centPosRevenueChannel, setCentPosRevenueChannel] = useState(0);
    const [centVaRevenueChannel, setCentVaRevenueChannel] = useState(0);
    const [acPosRevenueChannel, setAcPosRevenueChannel] = useState(0);
    const [acVaRevenueChannel, setAcVaRevenueChannel] = useState(0);


    const ac_DeviceChart = {
        options: {
            series: [acVaRevenueChannel, acPosRevenueChannel],
            chart: {
                type: 'donut',
                width: 300,
                height: 300
            },
            labels: ["BV", "POS"],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            legend: {
                position: 'right',
                itemMargin: {
                    horizontal: 0
                }
            },
            colors: ['#f1542d', '#ff65ff'],
            responsive: [{
                breakpoint: 1000,
                options: {
                    chart: {
                        width: 250,
                        height: 250
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        }
    };


    /// end metrics
   

    // start get metrics data


   

    const get_revenue_channel = (token, provider,from,to) => {
        console.log(token)
        const data = {
            "end_date": to,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": from
        };
   
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().CHANNEL_REVENUE, data)
            .then(res => {
                if (provider === "SAFARIBUS") {
                    const p = res.data.filter((o) => o.channel === "POS")[0].total_amount;
                    const v = res.data.filter((o) => o.channel === "VALIDATOR")[0].total_amount
                    setAcPosRevenueChannel(p)
                    setAcVaRevenueChannel(v)
                } else{
                    const p = res.data.filter((o) => o.channel === "POS")[0].total_amount;
                    const v = res.data.filter((o) => o.channel === "VALIDATOR")[0].total_amount
                    setCentPosRevenueChannel(p);
                    setCentVaRevenueChannel(v);
                }
            })
            .catch(err => {

            });
    };


    const [centRevenueOrganization, setCentRevenueOrganization] = useState([]);
    const [acRevenueOrganization, setAcRevenueOrganization] = useState([]);

    const get_revenue_organization = (token,provider,from,to) => {
        console.log(token)
        const data = {
            "end_date": to,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": from
        };
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_REVENUE_PER_ORGANIZATION, data)
            .then(res => {
                if(provider==="AC_GROUP"){
                    var r=[];
                    var v=[];
                    res.data.map((o)=>{
                       
                        r.push(o['organization_name']);
                        v.push(o['total_amount']);
                    });

                    setorganizationChart({
                        options: {
                            series: v,
                            chart: {
                                type: 'donut',
                                width: 300,
                                height: 300
                            },
                            labels: r,
                            noData: {
                                text: "No data yet",
                                align: "center",
                                verticalAlign: "middle",
                                offsetX: 0,
                                offsetY: 0,
                            },
                            legend: {
                                position: 'right',
                                itemMargin: {
                                    horizontal: 0
                                }
                            },
                            responsive: [{
                                breakpoint: 1000,
                                options: {
                                    chart: {
                                        width: 250,
                                        height: 250
                                    },
                                    legend: {
                                        position: 'right'
                                    }
                                }
                            }]
                        }
                    });

                    setCentRevenueOrganization(res.data);
                }else{
                    var r = [];
                    var v = [];
                    res.data.map((o) => {
                        r.push(o['organization_name']);
                        v.push(o['total_amount']);
                    });
                    set_ac_organizationChart({
                        options: {
                            series: v,
                            chart: {
                                type: 'donut',
                                width: 300,
                                height: 300
                            },
                            labels: r,
                            noData: {
                                text: "No data yet",
                                align: "center",
                                verticalAlign: "middle",
                                offsetX: 0,
                                offsetY: 0,
                            },
                            legend: {
                                position: 'right',
                                itemMargin: {
                                    horizontal: 0
                                }
                            },
                            responsive: [{
                                breakpoint: 1000,
                                options: {
                                    chart: {
                                        width: 250,
                                        height: 250
                                    },
                                    legend: {
                                        position: 'right'
                                    }
                                }
                            }]
                        }
                    });
                    setAcRevenueOrganization(res.data);
                }
            })
            .catch(err => {

            });
    };

    const [centRevenueRoute, setCentRevenueRoute] = useState([]);
    const [acRevenueRoute, setAcRevenueRoute] = useState([]);

    const get_revenue_route = (token, provider,from,to) => {
        const data = {
            "end_date": to,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": from
        };
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_REVENUE_PER_ROUTE, data)
            .then(res => {
                if (provider === "AC_GROUP") {

                    var r=[]
                    var v=[]

                    res.data.map((o)=>{
                        r.push(o['route_name'])
                        v.push(o['total_amount'])
                    })

                    set_route_performance_revenue({
                        series: [{
                            name: 'Percentage',
                            data: v
                        }],
                        options: {
                            chart: {
                                height: 350,
                                type: 'area'
                            },
                            noData: {
                                text: "No data yet",
                                align: "center",
                                verticalAlign: "middle",
                                offsetX: 0,
                                offsetY: 0,
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                curve: 'smooth'
                            },
                            xaxis: {
                                categories: r
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val + "%"
                                    }
                                }
                            },
                        },


                    });
                    setCentRevenueRoute(res.data);
                } else {
                    var r = []
                    var v = []

                    res.data.map((o) => {
                        r.push(o['route_name'])
                        v.push(o['total_amount'])
                    })

                    set_ac_route_performance_revenue({
                        series: [{
                            name: 'Percentage',
                            data: v
                        }],
                        options: {
                            chart: {
                                height: 350,
                                type: 'area'
                            },
                            noData: {
                                text: "No data yet",
                                align: "center",
                                verticalAlign: "middle",
                                offsetX: 0,
                                offsetY: 0,
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                curve: 'smooth'
                            },
                            xaxis: {
                                categories: r
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val + "%"
                                    }
                                }
                            },
                        },
                    });
                    setAcRevenueRoute(res.data);
                }
            })
            .catch(err => {

            });
    };


    const [centRevenuePlateNumber, setCentRevenuePlateNumber] = useState([]);
    const [acRevenuePlateNumber, setAcRevenuePlateNumber] = useState([]);

    const get_revenue_plate_number = (token, provider,from,to) => {
        const data = {
            "end_date": to,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": from
        };
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_REVENUE_PER_PLATE_NUMBER, data)
            .then(res => {
                if (provider === "AC_GROUP") {
                    var r=[]
                    var v=[]
                    res.data.map((o)=>{
                        r.push(o['plate_number'])
                        v.push(o['total_amount'])
                    })
                    setRevenue_bv(
                        {
                            options: {
                                series: [{
                                    name: 'Revenue',
                                    data: v
                                }],
                                chart: {
                                    height: 350,
                                    type: 'bar',
                                    tools: {
                                        download: false,
                                        selection: false,
                                        pan: false,
                                        reset: false,
                                    }
                                },

                                noData: {
                                    text: "No data yet",
                                    align: "center",
                                    verticalAlign: "middle",
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                                plotOptions: {
                                    bar: {
                                        columnWidth: '40%',
                                    }
                                },
                                dataLabels: {
                                    enabled: false,
                                    formatter: function (val) {
                                        return formatMoney(val) + " FRW";
                                    },
                                    offsetY: -20,
                                    style: {
                                        fontSize: '12px',
                                        colors: ["#304758"]
                                    }
                                },

                                xaxis: {
                                    categories: r,
                                    position: 'bottom',
                                    axisBorder: {
                                        show: false
                                    },
                                    axisTicks: {
                                        show: false
                                    },
                                    crosshairs: {
                                        fill: {
                                            type: 'gradient',
                                            gradient: {
                                                colorFrom: '#D8E3F0',
                                                colorTo: '#BED1E6',
                                                stops: [0, 100],
                                                opacityFrom: 0.4,
                                                opacityTo: 0.5,
                                            }
                                        }
                                    },
                                    tooltip: {
                                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                                            return '<div class="arrow_box" style="padding:10">' +
                                                '<span>' + formatMoney(parseInt(series[seriesIndex][dataPointIndex])) + ' FRW </span>' +
                                                '</div>'
                                        }
                                    },
                                },
                                yaxis: {
                                    axisBorder: {
                                        show: false
                                    },
                                    axisTicks: {
                                        show: false,
                                    },
                                    labels: {
                                        show: false,
                                        formatter: function (val) {
                                            return formatMoney(parseInt(val)) + " ";
                                        }
                                    }

                                },

                            }
                        });
                    setCentRevenuePlateNumber(res.data);
                } else {
                    var r = []
                    var v = []
                    res.data.map((o) => {
                        r.push(o['plate_number'])
                        v.push(o['total_amount'])
                    })
                    set_ac_Revenue_bv(
                        {
                            options: {
                                series: [{
                                    name: 'Revenue',
                                    data: v
                                }],
                                chart: {
                                    height: 350,
                                    type: 'bar',
                                    tools: {
                                        download: false,
                                        selection: false,
                                        pan: false,
                                        reset: false,
                                    }
                                },

                                noData: {
                                    text: "No data yet",
                                    align: "center",
                                    verticalAlign: "middle",
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                                plotOptions: {
                                    bar: {
                                        columnWidth: '40%',
                                    }
                                },
                                dataLabels: {
                                    enabled: false,
                                    formatter: function (val) {
                                        return formatMoney(val, 0) + " FRW";
                                    },
                                    offsetY: -20,
                                    style: {
                                        fontSize: '12px',
                                        colors: ["#304758"]
                                    }
                                },

                                xaxis: {
                                    categories: r,
                                    position: 'bottom',
                                    axisBorder: {
                                        show: false
                                    },
                                    axisTicks: {
                                        show: false
                                    },
                                    crosshairs: {
                                        fill: {
                                            type: 'gradient',
                                            gradient: {
                                                colorFrom: '#D8E3F0',
                                                colorTo: '#BED1E6',
                                                stops: [0, 100],
                                                opacityFrom: 0.4,
                                                opacityTo: 0.5,
                                            }
                                        }
                                    },
                                    tooltip: {
                                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                                            return '<div class="arrow_box" style="padding:10">' +
                                                '<span>' + formatMoney(parseInt(series[seriesIndex][dataPointIndex]), 0) + ' FRW </span>' +
                                                '</div>'
                                        }
                                    },
                                },
                                yaxis: {
                                    axisBorder: {
                                        show: false
                                    },
                                    axisTicks: {
                                        show: false,
                                    },
                                    labels: {
                                        show: false,
                                        formatter: function (val) {
                                            return formatMoney(parseInt(val), 0) + " ";
                                        }
                                    }

                                },

                            }
                        });
                    setAcRevenuePlateNumber(res.data);
                }
            })
            .catch(err => {

            });
    };


    const [centRevenueTickets, setCentRevenueTickets] = useState([]);
    const [acRevenueTickets, setAcRevenueTickets] = useState([]);

    const [centTaps,setCentTaps]=useState(0)
    const [acTaps, setAcTaps] = useState(0)

    const [centAmount,setCentAmount] = useState(0)
    const [acAmount, setAcAmount] = useState(0)


    const [centPos,setCentPos]=useState(0);
    const [centBv,setCentBv]=useState(0);

    

    const get_revenue_tickets = (token, provider,from,to) => {
        const data = {
            "end_date": to,
            "organization_name": null,
            "plate_number": null,
            "provider": provider,
            "route_name": null,
            "start_date": from
        };
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_REVENUE_TICKETS,data)
            .then(res => {
                if (provider === "AC_GROUP") {
                    var totalAmount = res.data.reduce((a, b) => {
                        return a + parseInt(b.amount);
                    }, 0);
                    setCentAmount(totalAmount)
                    var totalTickets = res.data.length;
                    // setCentTaps(totalTickets)
                    var pos=0;
                    var bv=0;
                    res.data.map((o)=>{
                        if (o['device_id'].includes("P")){
                            pos++
                        }else{
                            bv++
                        }
                    })
                    setCentPos(pos);
                    setCentBv(bv);
                } else {
                    var totalAmount = res.data.reduce((a, b) => {
                        return a + parseInt(b.amount);
                    }, 0);
                    // setAcAmount(totalAmount)
                    var totalTickets = res.data.length;
                    // setAcTaps(totalTickets)
                }
            })
            .catch(err => {

            });
    };



    const [centWeeklyLebal,setCentWeeklyLebal]=useState([]);
    const [centWeeklyValue, setCentWeeklyValue] = useState([]);

    const [acWeeklyLebal, setAcWeeklyLebal] = useState([]);
    const [acWeeklyValue, setAcWeeklyValue] = useState([]);

    const get_weekly_report=(token,provider)=>{
        const data = {"provider": provider};
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_WEEK_INTER_REPORT, data)
            .then(res => {
                if (provider === "AC_GROUP") {
                    const v=[];
                    const l=[];
                    res.data.map((o) => {
                        l.push(dayName(o['day']))
                        v.push(o['total_amount'])
                    })
                    setCentWeeklyLebal(l);
                    setCentWeeklyValue(v);
                } else {
                    const v = [];
                    const l = [];
                    res.data.map((o) => {
                        l.push(dayName(o['day']))
                        v.push(o['total_amount'])
                    })
                    setAcWeeklyLebal(l);
                    setAcWeeklyValue(v);
                }
            })
            .catch(err => {

            });
    }


    const [centMonthlyLebal,setCentMonthlyLebal]=useState([])
    const [centMonthlyValue,setCentMonthlyValue]=useState([])

    const [acMonthlyLebal, setAcMonthlyLebal] = useState([])
    const [acMonthlyValue, setAcMonthlyValue] = useState([])


    const get_monthly_report = (token, provider,year) => {
        const data = {
            "provider": provider,
            "year": year
        }
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const revenueOrganization = axios.create(new ReportingService().setHeaders(token));
        revenueOrganization.post(new ReportingService().GET_MONTH_INTER_REPORT, data)
            .then(res => {
                if (provider === "AC_GROUP") {
                    const v = [];
                    const l = [];
                    res.data.map((o) => {
                        l.push(monthName(o['month']))
                        v.push(o['total_amount'])
                    })
                    setCentMonthlyLebal(l);
                    setCentMonthlyValue(v);
                } else {
                    const v = [];
                    const l = [];
                    res.data.map((o) => {
                        l.push(monthName(o['month']))
                        v.push(o['total_amount'])
                    })
                    setAcMonthlyLebal(l);
                    setAcMonthlyValue(v);
                }
            })
            .catch(err => {

            });
    }

    // end get metrics data

    const route_performance_passenger = {
        options: {
            series: [centAmount, acAmount],
            chart: {
                type: 'donut',
                width: 300,
                height: 300
            },
            labels: ["CENTRIKA", "AC Mobility"],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            legend: {
                position: 'right',
                itemMargin: {
                    horizontal: 0
                }
            },
            colors: ['#ed1c25', '#be8a36'],
            responsive: [{
                breakpoint: 1000,
                options: {
                    chart: {
                        width: 250,
                        height: 250
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        }
    };

    const deviceChart ={
        options: {
            series: [centPosRevenueChannel, centVaRevenueChannel],
            chart: {
                type: 'donut',
                width: 300,
                height: 300
            },
            labels: ["POS", "BV"],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            legend: {
                position: 'right',
                itemMargin: {
                    horizontal: 0
                }
            },
            colors: ['#2328de', '#febe37'],
            responsive: [{
                breakpoint: 1000,
                options: {
                    chart: {
                        width: 250,
                        height: 250
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }]
        }
    };

    const cent_monthly_report = {


            series: [{
                name: 'Percentage',
                data: centMonthlyValue
            }],
            options: {
                chart: {
                    height: 350,
                    type: 'area'
                },
                noData: {
                    text: "No data yet",
                    align: "center",
                    verticalAlign: "middle",
                    offsetX: 0,
                    offsetY: 0,
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    categories: centMonthlyLebal
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return formatMoney(val, 0) 
                        }
                    }
                },
            },

    };

    const ac_monthly_report = {

        series: [{
            name: 'Percentage',
            data: acMonthlyValue
        }],
        options: {
            chart: {
                height: 350,
                type: 'area'
            },
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: acMonthlyLebal
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatMoney(val, 0) 
                    }
                }
            },
        },
    };

    const cent_weekly_report = {


        series: [{
            name: 'Percentage',
            data: centWeeklyValue
        }],
        options: {
            chart: {
                height: 350,
                type: 'area'
            },
            colors: ["#febe37"],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: centWeeklyLebal
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatMoney(val, 0) 
                    }
                }
            },
        },
    };

    const ac_weekly_report = {

        series: [{
            name: 'Percentage',
            data: acWeeklyValue
        }],
        options: {
            chart: {
                height: 350,
                type: 'area'
            },
            colors: ["#ff8bde"],
            noData: {
                text: "No data yet",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0,
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: acWeeklyLebal
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatMoney(val, 0) 
                    }
                }
            },
        },
    };


//  get day name
const dayName=(day)=>{
    const weekdays = new Array(7);
    weekdays[0] = "Monday";
    weekdays[1] = "Tuesday";
    weekdays[2] = "Wednesday";
    weekdays[3] = "Thursday";
    weekdays[4] = "Friday";
    weekdays[5] = "Saturday";
    weekdays[6] = "Sunday";
    return weekdays[parseInt(day)-1];
}

    //  get month name
    const monthName = (month) => {
    const months = new Array(7);
    months[0] = "January";
    months[1] = "Feruary";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "july";

    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";
     return months[parseInt(month) - 1];
    }

    
    const [range, setRange] = useState({ index: 0, acnhor: null });

    const onFromChange = (date) => {
        setDay(Format(date, ["yyyy-MM-dd",]));
        setRange({ ...range, index: null });

        // get_revenue_organization(acData.token, "AC_GROUP",Format(date, ["yyyy-MM-dd",]),endDay)
        // get_revenue_organization(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), endDay)

        // get_revenue_route(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), endDay)
        // get_revenue_route(acData.token, "AC_GROUP", Format(date, ["yyyy-MM-dd",]), endDay)

        // get_revenue_plate_number(acData.token, "AC_GROUP", Format(date, ["yyyy-MM-dd",]), endDay)
        // get_revenue_plate_number(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), endDay)

        // get_revenue_tickets(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), endDay)
        // get_revenue_tickets(acData.token, "AC_GROUP", Format(date, ["yyyy-MM-dd",]), endDay)

        // get_revenue_channel(acData.token, "SAFARIBUS", Format(date, ["yyyy-MM-dd",]), endDay)
        // get_revenue_channel(acData.token, "AC_GROUP", Format(date, ["yyyy-MM-dd",]), endDay)

    };
    const onToChange = (date) => {
        setEndDay(Format(date, ["yyyy-MM-dd",]));
        setRange({ ...range, index: null });

        // get_revenue_organization(acData.token, "AC_GROUP", day, Format(date, ["yyyy-MM-dd",]))
        // get_revenue_organization(acData.token, "SAFARIBUS", day, Format(date, ["yyyy-MM-dd",]))

        // get_revenue_route(acData.token, "SAFARIBUS", day, Format(date, ["yyyy-MM-dd",]))
        // get_revenue_route(acData.token, "AC_GROUP", day, Format(date, ["yyyy-MM-dd",]))

        // get_revenue_plate_number(acData.token, "AC_GROUP",day, Format(date, ["yyyy-MM-dd",]))
        // get_revenue_plate_number(acData.token, "SAFARIBUS",day, Format(date, ["yyyy-MM-dd",]))

        // get_revenue_tickets(acData.token, "SAFARIBUS",day, Format(date, ["yyyy-MM-dd",]))
        // get_revenue_tickets(acData.token, "AC_GROUP",day, Format(date, ["yyyy-MM-dd",]))

        // get_revenue_channel(acData.token, "SAFARIBUS",day, Format(date, ["yyyy-MM-dd",]))
        // get_revenue_channel(acData.token, "AC_GROUP",day, Format(date, ["yyyy-MM-dd",]))

    };




    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={classes.root}>
                <CssBaseline />
                <Dialog
                    open={logoutOpen}
                    onClose={() => setLogoutOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to logout of your account?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setLogoutOpen(false)} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                localStorage.removeItem("nx_cent");
                                history.replace("/");
                            }}
                            color="primary"
                            autoFocus
                        >
                            Logout
                        </Button>
                    </DialogActions>
                </Dialog>

                    <Grid container spacing={2} className={classes.container}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box display="flex"><Home fontSize="large" color="primary" /><Typography style={{ flexGrow: 1 }} variant="h6">Interoperability Dashboard</Typography><IconButton 
                            onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
                        ><Event color="primary" fontSize="large" /> <Typography variant="h6">{day===endDay?day:day+"-"+endDay}</Typography> </IconButton></Box>
                        </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <img src={CentrikaLogo} className={classes.iconCent} />
                    </Grid>


                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <img src={AcGroupLogo} className={classes.icon} />
                    </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box width={1} display="flex" justifyContent="center">
                                    <Box flexGrow={1}>
                                        <Typography color="textSecondary">Total Centrika Taps</Typography>
                                        <Box mt={1} mb="4px" flexGrow={1}>
                                        <Typography variant="h6">{centTaps}</Typography>
                                        </Box>

                                    </Box>
                                <img src={TicketsIcon} height={50} />
                                    {/* <SwapHoriz color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box width={1} display="flex" justifyContent="center">
                                <Box flexGrow={1}>
                                    <Typography color="textSecondary">Total AC Mobility Taps</Typography>
                                    <Box mt={1} mb="4px" flexGrow={1}>
                                        <Typography variant="h6">{acTaps}</Typography>
                                    </Box>

                                </Box>
                                <img src={TicketsIcon} height={50}/>
                                {/* <SwapHoriz color="primary" fontSize="large" /> */}
                            </Box>
                        </Paper>
                    </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box display="flex" width={1}>
                                    <Box flexGrow={1}>
                                    <Typography color="textSecondary">Total Centrika Amount</Typography>
                                        <Box mt={1} mb="4px">
                                        <Typography variant="h6">{formatMoney(centAmount,0) + " " + currency} RWF</Typography>
                                        </Box>

                                    </Box>
                                    <img src={MoneyIcon} height={50}/>
                                    {/* <AccountBalanceWallet color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box display="flex" width={1}>
                                <Box flexGrow={1}>
                                    <Typography color="textSecondary">Total AC Mobility Amount</Typography>
                                    <Box mt={1} mb="4px">
                                        <Typography variant="h6">{formatMoney(acAmount,0) + " " + currency} RWF</Typography>
                                    </Box>

                                </Box>
                                <img src={MoneyIcon} height={50} />
                                {/* <AccountBalanceWallet color="primary" fontSize="large" /> */}
                            </Box>
                        </Paper>
                    </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Paper elevation={0} className={classes.paper}>
                                <Box display="flex" width={1}>
                                    <Box flexGrow={1}>
                                        <Typography color="textSecondary">
                                        Total Centrika Interchange Fee (<b>1.5%</b>)
                                        </Typography>
                                        <Box mt={1} mb="4px">
                                        <Typography variant="h6">{formatMoney((centAmount*1.5)/100,0)} RWF</Typography>
                                        </Box>

                                    </Box>
                                <img src={InterchangeIcon} height={50}/>
                                    {/* <AirportShuttle color="primary" fontSize="large" /> */}
                                </Box>
                            </Paper>
                        </Grid>


                    
                    
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Paper elevation={0} className={classes.paper}>
                            <Box display="flex" width={1}>
                                <Box flexGrow={1}>
                                    <Typography color="textSecondary">
                                        Total AC Mobility Interchange Fee (<b>1.5%</b>)
                                    </Typography>
                                    <Box mt={1} mb="4px">
                                        <Typography variant="h6">{formatMoney((acAmount*1.5)/100,0)} RWF</Typography>
                                    </Box>

                                </Box>
                                <img src={InterchangeIcon} height={50} />
                                {/* <AirportShuttle color="primary" fontSize="large" /> */}
                            </Box>
                        </Paper>
                    </Grid>

                   

                        {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box display="flex">

                                <Box>
                                    <Chip mt={4} avatar={<Event />} label="View Report" size="large" variant="outlined" onClick={() => { setFilterDialog(true); setFilterType("VIEW_REPORT"); }} />
                                </Box>
                                <Typography style={{ flexGrow: 1 }} />

                                <Chip mt={4} avatar={<FilterList />} label="Filter" size="large" variant="outlined" onClick={() => { setFilterDialog(true); setCompany(""); setIsValidDownload(false); setFilterType("DOWNLOAD_REPORT"); }} /></Box>
                        </Grid> */}


                        {/* <Grid item xs={12} md={12} lg={12} sm={12}>

                            {transactions.length == 0 && !transactionLoad && (
                                <Box
                                    p={2}
                                    height={1}
                                    display="flex"
                                    alignItems="center"
                                    flexDirection="column"
                                    justifyContent="center"
                                >
                                    <Box mt={2}>
                                        <img src={Empty} alt="Empty data" height={200} />
                                    </Box>
                                    <Typography color="textSecondary">
                                        There are no ticktes generated yet!
                                    </Typography>
                                </Box>
                            )}
                            <Grid container spacing={2}>

                                {transactionLoad === false ? transactions.map((o, i) => (
                                    <Grid item xs={6} sm={4} md={4} lg={2}>
                                        <Box
                                            display="flex"
                                            // justifyContent="center"
                                            // alignItems="center"
                                            flexDirection="column"
                                        >
                                            <Box
                                                height="250px"
                                                width={1}
                                                display="flex"
                                                // justifyContent="center"
                                                alignItems="center"
                                                flexDirection="column"
                                                border={1}
                                                borderStyle="dotted"
                                                borderRadius="borderRadius"
                                                borderColor="grey.300"
                                                className={classes.btn2}
                                            >
                                                <Box ml={1} mb={-4}><img src={Buses} width={"100px"} /></Box>
                                                <Box ml={1}><Typography variant="h7"><b>{o.organization_name}</b></Typography></Box>

                                                <Box mt={3}>
                                                    <Grid container spacing={4}>
                                                        <Grid item>
                                                            <Box>
                                                                <Typography color="textSecondary">No of Taps</Typography>
                                                                <Typography><b>{o.total_taps}</b></Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item>
                                                            <Box>
                                                                <Typography color="textSecondary">Amount</Typography>
                                                                <Typography><b>{o.total_amount}</b></Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box ml={1} mt={2}><Chip label="View Raw Data" color="primary" clickable onClick={() => { console.log(o.organization_name); setCompany(o.organization_name); setFilterDialog(true); setIsValidDownload(false); setFilterType("DOWNLOAD_REPORT"); }} variant="outlined" /></Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )) : [1, 2, 3, 4, 5].map((o, i) => (
                                    <Grid item xs={6} sm={4} md={4} lg={2}>
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            justifyContent="center"
                                            alignItems="center"
                                            borderRadius={15}
                                            width={1}
                                        >
                                            <Skeleton
                                                variant="rect"
                                                height={250}
                                                width={"100%"}
                                                style={{ borderRadius: 15 }}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid> */}

                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: BV vs POS</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={deviceChart.options} series={deviceChart.options.series} type="donut" height={260} />


                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: BV vs POS</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={ac_DeviceChart.options} series={ac_DeviceChart.options.series} type="donut" height={260} />


                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={12} sm={12} lg={12}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }}>CENTRIKA vs AC Mobility</Typography>
                                {/* <img style={{ margin: 5 }} src={passenger} width="30px" height="30px" /> */}
                            </Box>

                            <Chart options={route_performance_passenger.options} series={route_performance_passenger.options.series} type="donut" height={300} />
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: Company performance</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={organizationChart.options} series={organizationChart.options.series} type="donut" height={260} />


                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: Company performance</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={ac_organizationChart.options} series={ac_organizationChart.options.series} type="donut" height={260} />


                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <Paper elevation={0}>
                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: Revenue per route</Typography><AccountBalanceWallet color="secondary" /></Box>

                            <Chart options={route_performance_revenue.options} series={route_performance_revenue.series} type="area" height={250} />

                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <Paper elevation={0}>
                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: Revenue per route</Typography><AccountBalanceWallet color="secondary" /></Box>

                            <Chart options={ac_route_performance_revenue.options} series={ac_route_performance_revenue.series} type="area" height={250} />

                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <Paper className={classes.paper1} elevation={0}>
                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: Revenue per bus</Typography><DirectionsBus color="secondary" /></Box>
                            <Chart options={revenue_bv.options} series={revenue_bv.options.series} type="bar" height="300px" />
                        </Paper>
                    </Grid>


                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <Paper className={classes.paper1} elevation={0}>
                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: Revenue per bus</Typography><DirectionsBus color="secondary" /></Box>
                            <Chart options={ac_revenue_bv.options} series={ac_revenue_bv.options.series} type="bar" height="300px" />
                        </Paper>
                    </Grid>

                    
                    
                    
                    

                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: Weekly Report</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={cent_weekly_report.options} series={cent_weekly_report.series} type="bar" height={260} />


                        </Paper>
                    </Grid>


                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: Weekly Report</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={ac_weekly_report.options} series={ac_weekly_report.series} type="bar" height={260} />


                        </Paper>
                    </Grid>



                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >CENTRIKA :: Monthly Report</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={cent_monthly_report.options} series={cent_monthly_report.series} type="bar" height={260} />


                        </Paper>
                    </Grid>


                    <Grid item xs={12} md={6} lg={6} sm={6}>
                        <Paper elevation={0}>

                            <Box m={1} display="flex"><Typography style={{ flexGrow: 1 }} >AC Mobility :: Montly Report</Typography><DirectionsBus color="secondary" /></Box>

                            <Chart options={ac_monthly_report.options} series={ac_monthly_report.series} type="bar" height={260} />


                        </Paper>
                    </Grid>


                   

                        
                  

                   

                        


                    </Grid>
               


                {/* filter data  */}

                <Dialog
                    maxWidth="sm"
                    fullWidth
                    open={filterDialog}
                    onClose={() => {

                        setFilterDialog(false);

                    }}
                    aria-labelledby="filter"
                    aria-describedby="filter"
                >
                    <DialogTitle id="filter">{"Filter Raw Data"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText >
                            <Box>

                                <Box>
                                    <DatePicker
                                        fullWidth
                                        disableToolbar
                                        variant="inline"
                                        format="yyyy-MM-dd"
                                        margin="dense"
                                        maxDate={endDay}
                                        autoOk
                                        label={<Translate id="reports.forms.labels.from" />}
                                        value={day}
                                        inputVariant="outlined"
                                        onChange={(v) => {
                                            console.log("date::" + v)
                                            setDay(Format(v, ["yyyy-MM-dd",]))
                                            setIsValidDownload(false);
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            style: { paddingRight: 0 },
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <DatePicker
                                        fullWidth
                                        disableToolbar
                                        variant="inline"
                                        format="yyyy-MM-dd"
                                        margin="dense"
                                        maxDate={new Date()}
                                        minDate={day}
                                        autoOk
                                        label={<Translate id="reports.forms.labels.to" />}
                                        value={endDay}
                                        inputVariant="outlined"
                                        onChange={(v) => {
                                            console.log("end date::" + v)
                                            setEndDay(Format(v, ["yyyy-MM-dd",]))
                                            setIsValidDownload(false);
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            style: { paddingRight: 0 },
                                        }}
                                    />
                                </Box>

                            </Box>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={() => {

                            setFilterDialog(false);

                        }} color="secondary" variant="outlined" >
                            close
                        </Button>
                        {isValidDownload && <CSVLink data={jsonData} filename={"generated_tickets_" + day + "_" + endDay + ".csv"} headers={headers}>
                            <Button disableElevation disabled={filterLoad} color="primary" variant="contained" >
                                {filterLoad ? <CircularProgress size={25} color="secondary" /> : "Donwload CSV"}
                            </Button>
                        </CSVLink>}


                        {/* <CSVDownload data={jsonData} target="_blank" /> */}

                        {!isValidDownload && <Button disableElevation disabled={filterLoad} color="primary" onClick={() => {
                            if (filterType == "DOWNLOAD_REPORT" && company === "") {
                                get_ac_group_tickets()
                            } else if (filterType == "DOWNLOAD_REPORT" && company !== "") {
                                get_ac_group_tickets_per_company()
                            } else if (filterType == "VIEW_REPORT") {
                                get_tickets_summary(acData.token)
                                setFilterDialog(false);
                            }

                        }} variant="contained" >
                            {filterLoad ? <CircularProgress size={25} color="secondary" /> : "Filter"}
                        </Button>}

                    </DialogActions>
                </Dialog>

                {/* filter data  */}


                {/* select range popup */}

                <Popover
                    id={"pop-id"}
                    open={range.acnhor != null}
                    anchorEl={range.acnhor}
                    onClose={() => setRange({ ...range, acnhor: null })}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    elevation={4}
                >
                    <Box p={2}>
                        <Typography color="textSecondary">Select date range</Typography>
                        <Box mt={2} mb={2}>
                            <Box>
                                <DatePicker
                                    fullWidth
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="dense"
                                    maxDate={endDay}
                                    autoOk
                                    label={<Translate id="reports.forms.labels.from" />}
                                    value={day}
                                    inputVariant="outlined"
                                    onChange={onFromChange}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: { paddingRight: 0 },
                                    }}
                                />
                            </Box>
                            <Box>
                                <DatePicker
                                    fullWidth
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="dense"
                                    maxDate={new Date()}
                                    minDate={day}
                                    autoOk
                                    label={<Translate id="reports.forms.labels.to" />}
                                    value={endDay}
                                    inputVariant="outlined"
                                    onChange={onToChange}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: { paddingRight: 0 },
                                    }}
                                />
                            </Box>
                            <Box>
                                <Button color="primary" disableElevation={false} variant='contained'
                                    disabled={transactionLoad}
                                    onClick={(e) => {
                                        get_revenue_organization(acData.token, "AC_GROUP",day, endDay)
                                        get_revenue_organization(acData.token, "SAFARIBUS", day, endDay)
                                        get_revenue_route(acData.token, "SAFARIBUS", day, endDay)
                                        get_revenue_route(acData.token, "AC_GROUP", day, endDay)
                                        get_revenue_plate_number(acData.token, "AC_GROUP", day, endDay)
                                        get_revenue_plate_number(acData.token, "SAFARIBUS", day, endDay)
                                        get_revenue_tickets(acData.token, "SAFARIBUS", day, endDay)
                                        get_revenue_tickets(acData.token, "AC_GROUP", day, endDay)
                                        get_revenue_channel(acData.token, "SAFARIBUS", day, endDay)
                                        get_revenue_channel(acData.token, "AC_GROUP", day, endDay)
                                        load_meta_data(acData.token, "AC_GROUP", day, endDay)
                                        load_meta_data(acData.token, "SAFARIBUS", day, endDay)
                                    }}
                                >{transactionLoad ? (<CircularProgress size={25} />) : ("Filter")}</Button>
                            </Box>
                        </Box>
                    </Box>
                </Popover>

                {/* select range popop */}


            </div>
        </MuiPickersUtilsProvider>
    );
}

export default withLocalize(Dashboard);